<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Chi tiết dữ liệu kho hàng
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                        </div>
                    </div>
                    <div class="list-partners-component">
                        <div class="col-sm-12 d-flex gap-3 flex-wrap align-content-start flex-column align-items-start">
                            <div class="col-sm-4">
                                <InputTextNormal
                                        :label="dataExchangeDelivery.exchange_delivery_name.label"
                                        :id="dataExchangeDelivery.exchange_delivery_name.id"
                                        :placeholder="dataExchangeDelivery.exchange_delivery_name.placeholder"
                                        :value-default="dataExchangeDelivery.exchange_delivery_name.value"
                                        :error-text="dataExchangeDelivery.exchange_delivery_name.error"
                                        :is-error="dataExchangeDelivery.exchange_delivery_name.isError"
                                        :required="dataExchangeDelivery.exchange_delivery_name.required"
                                        :disabled="dataExchangeDelivery.exchange_delivery_name.disabled"
                                ></InputTextNormal>
                            </div>
                            <div class="col-sm-4">
                                <SelectNormal
                                        :label="dataExchangeDelivery.partner_id.label"
                                        :id="dataExchangeDelivery.partner_id.id"
                                        :placeholder="dataExchangeDelivery.partner_id.placeholder"
                                        :value-default="dataExchangeDelivery.partner_id.value"
                                        :error-text="dataExchangeDelivery.partner_id.error"
                                        :required="dataExchangeDelivery.partner_id.required"
                                        :disabled="dataExchangeDelivery.partner_id.disabled"
                                        :options="dataExchangeDelivery.partner_id.options"
                                ></SelectNormal>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-12 d-flex justify-content-between align-content-center mb-2">
                                    <label class="col-form-label" for="listProducts">SẢN PHẨM</label>
                                </div>
                                <div class="col-sm-12 d-flex justify-content-between align-items-center" v-if="!disableFields && delivery.partner_assignee_id">
                                    <div class="d-flex align-content-center mb-2 gap-2">
                                        <InputCheckboxOne  id="storeDelivery" :disabled="true"></InputCheckboxOne>
                                        <div>Sử dụng làm mẫu dữ liệu giao hàng mới</div>
                                    </div>
                                </div>
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th class="text-center" scope="col" v-for="header in dataHeaderTable" :key="header.order" :style="{ 'width': header.width }">{{header.label}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="listProductsSelected.length > 0" v-for="(product, key) in listProductsSelected" :key="product.id">
                                        <td class="text-center">{{product.product_name}}</td>
                                        <td class="text-center">{{product.product_code}}</td>
                                        <td class="text-center">{{CommonService.formatPrice(product.product_selling_price, 'VND')}}</td>
                                        <td class="text-center">{{product.product_quantity}}</td>
                                        <td class="text-center">{{product.tax_rate + '%'}}</td>
                                        <td class="text-center">{{(product.product_unit  === '') ? 'pcs' : product.product_unit }}</td>
                                        <td class="text-center">{{CommonService.formatPrice(product.total_price_origin, 'VND')}}</td>
                                        <td class="text-center">{{CommonService.formatPrice(product.total_price_tax, 'VND')}}</td>
                                    </tr>
                                    <tr v-if="listProductsSelected.length > 0">
                                        <td :colspan="type === AppConstant.TAB_OWNER ? 9 : 8" class="text-end">
                                            <span>Tổng tiền gốc: {{CommonService.formatPrice(totalPrice, 'VND')}}</span>
                                            <span class="ms-4">Tổng tiền tính thuế: {{CommonService.formatPrice(totalPriceWithTax, 'VND')}}</span>
                                        </td>
                                    </tr>
                                    <tr v-else>
                                        <td :colspan="type === AppConstant.TAB_OWNER ? 9 : 8" class="text-center">Chưa có sản phẩm được chọn!</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<LoadingComponent v-if="isLoading"></LoadingComponent>